module.exports = __webpack_public_path__ + "static/media/oliwa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/oliwa.png
// module id = 875
// module chunks = 0